import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import '@vant/touch-emulator';
import '@/styles/index.css';

/**
 * 应用入口
 * 微信服务号 H5 端：家长/学生通过微信内嵌浏览器访问
 * UI 组件库 Vant 4（unplugin-vue-components 按需自动导入）
 */
const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
